import {
    postFilesTransportLoading,
    postFilesTransportRequest,
    postFilesTransportSuccess,
    postFilesTransportReject,
    postFilesTransportReset
} from "../../actions/filesTransport/post";

export const postFilesTransport = (formData) => async (dispatch, getState) => {
    dispatch(postFilesTransportLoading());
    try {
        const { data } = await postFilesTransportRequest(formData, getState);
        dispatch(postFilesTransportSuccess(data))
    } catch (error) {
        dispatch(postFilesTransportReject(error))
    } finally {
        setTimeout(() => { dispatch(postFilesTransportReset()) }, 3000);
    }
    return Promise.resolve();
};